var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper d-flex",attrs:{"id":"main-content"}},[_c('Load',{attrs:{"isLoading":_vm.isLoading}}),_c('div',{attrs:{"id":"main-panel"}},[_c('TopNavBar'),_c('Content')],1),_c('ContentFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }